// Adapted from ReactBits (https://reactbits.dev) — MIT License
export default function StarBorder({
  as: Component = 'button',
  className = '',
  color = 'cyan',
  speed = '6s',
  children,
  ...rest
}) {
  return (
    <Component
      className={className}
      style={{
        position: 'relative',
        display: 'inline-block',
        borderRadius: '0.75rem',
        overflow: 'hidden',
        padding: '1px 0',
        ...rest.style,
      }}
      {...rest}
    >
      {/* Bottom moving gradient */}
      <div style={{
        position: 'absolute',
        width: '300%',
        height: '50%',
        opacity: 0.7,
        bottom: -12,
        right: '-250%',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${color}, transparent 10%)`,
        animation: `star-move-bottom ${speed} linear infinite alternate`,
        zIndex: 0,
      }} />
      {/* Top moving gradient */}
      <div style={{
        position: 'absolute',
        width: '300%',
        height: '50%',
        opacity: 0.7,
        top: -12,
        left: '-250%',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${color}, transparent 10%)`,
        animation: `star-move-top ${speed} linear infinite alternate`,
        zIndex: 0,
      }} />
      {/* Content */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        borderRadius: '0.75rem',
      }}>
        {children}
      </div>
      <style>{`
        @keyframes star-move-bottom {
          0% { transform: translate(0%, 0%); opacity: 1; }
          100% { transform: translate(-100%, 0%); opacity: 0; }
        }
        @keyframes star-move-top {
          0% { transform: translate(0%, 0%); opacity: 1; }
          100% { transform: translate(100%, 0%); opacity: 0; }
        }
      `}</style>
    </Component>
  );
}
